import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import parse from "url-parse";
import Banner from "./Banner";
import Confirmation from "./Confirmation";
import ContactPreferences from "./ContactPreferences";
import Modal from "../Modal";
import { removeURLParameter } from "../../../helpers/url";
import {
  getValueFromLocalStorage,
  setLocalStorage
} from "../../../helpers/webStorage";

const GDPR_STORAGE_KEY = "Asos.GdprBanner";

class GDPR extends Component {
  state = {
    fetchPreferencesError: false,
    showBanner: true,
    showModal: false
  };

  componentDidMount() {
    this.setState({
      showModal: !!this.isContactAvailable()
    });
  }

  componentWillReceiveProps(nextProps) {
    const gdprSessionStorageObject = JSON.parse(
      getValueFromLocalStorage(GDPR_STORAGE_KEY)
    );

    const customerShouldNotSeeBanner = !!(
      gdprSessionStorageObject &&
      !!(nextProps.customerGuid === gdprSessionStorageObject.customerGuid) &&
      !!(gdprSessionStorageObject.expiry > new Date().toISOString())
    );

    this.setState(state => ({
      showBanner: state.showBanner && !customerShouldNotSeeBanner
    }));
  }

  dismissGdprNotificationsForSession = () => {
    const { customerGuid } = this.props;
    const expiryDate = new Date();
    expiryDate.setHours(expiryDate.getHours() + 8); // set 8 hour expiry from now

    const setLocalStorageValues = JSON.stringify({
      customerGuid: customerGuid,
      expiry: expiryDate.toISOString()
    });

    setLocalStorage(GDPR_STORAGE_KEY, setLocalStorageValues);
  };

  handleBannerClick = callback => {
    const { setUserPreferences } = this.props;

    this.setState({
      isPreferencesLoading: true
    });

    return setUserPreferences()
      .then(() => {
        this.dismissGdprNotificationsForSession();
        this.setState({
          fetchPreferencesError: false,
          isPreferencesLoading: false,
          showBanner: false,
          showModal: true
        });
      })
      .then(() => {
        if (callback) {
          callback();
        }
      })
      .catch(() =>
        this.setState({
          fetchPreferencesError: true,
          isPreferencesLoading: false
        })
      );
  };

  handleClose = () => {
    this.setState({
      showBanner: false,
      showModal: false
    });

    const url = removeURLParameter(window.location.href, "contact");
    window.history.replaceState({}, "", url);
  };

  isContactAvailable() {
    if (typeof window !== "undefined" && window.location) {
      return "contact" in parse(window.location.href, true).query;
    }
    return false;
  }

  getContact() {
    if (typeof window !== "undefined" && window.location) {
      const url = parse(window.location.href, true);
      return url.query.contact;
    }
    return false;
  }

  getOptedIn() {
    const { hasReconsented } = this.props;
    const hasContactInAsAQueryParam = this.getContact()
      ? !!(this.getContact().toLowerCase() === "in")
      : false;

    return hasReconsented || hasContactInAsAQueryParam;
  }

  renderPreferences() {
    const {
      ctaRef,
      hasError,
      isOptInLoading,
      isOptOutLoading,
      isReconsentRequired,
      optIn,
      optOut,
      preferences,
      privacyUrlSegment,
      testContent,
      termsUrlSegment
    } = this.props;

    if (this.isContactAvailable()) {
      return null;
    }

    if (!isReconsentRequired) {
      return null;
    }

    return (
      <ContactPreferences
        ctaRef={ctaRef}
        hasError={hasError}
        isOptInLoading={isOptInLoading}
        isOptOutLoading={isOptOutLoading}
        optIn={optIn}
        optOut={optOut}
        preferences={preferences}
        privacyUrlSegment={privacyUrlSegment}
        testContent={testContent}
        termsUrlSegment={termsUrlSegment}
      />
    );
  }

  renderConfirmation() {
    const { ctaRef, isReconsentRequired, hasReconsented } = this.props;

    if (!this.isContactAvailable()) {
      if (isReconsentRequired) {
        return null;
      }

      if (hasReconsented === null) {
        return null;
      }
    }

    return (
      <Confirmation
        ctaRef={ctaRef}
        isOptedIn={this.getOptedIn()}
        onClose={this.handleClose}
      />
    );
  }

  render() {
    const { isReconsentRequired, testContent, testIsLoaded } = this.props;
    const {
      fetchPreferencesError,
      isPreferencesLoading,
      showBanner,
      showModal
    } = this.state;

    const shouldShowBanner = isReconsentRequired && showBanner && testIsLoaded;

    return (
      <Fragment>
        <Modal isOpen={showModal} onClose={this.handleClose}>
          {this.renderPreferences()}
          {this.renderConfirmation()}
        </Modal>
        {shouldShowBanner && (
          <Banner
            chooseOptionsAction={this.handleBannerClick}
            dismissAction={this.dismissGdprNotificationsForSession}
            hasErrored={fetchPreferencesError}
            greeting={testContent && testContent.greeting}
            isLoading={isPreferencesLoading}
            onClick={this.handleBannerClick}
          />
        )}
      </Fragment>
    );
  }
}

GDPR.propTypes = {
  customerGuid: PropTypes.string,
  ctaRef: PropTypes.string.isRequired,
  hasError: PropTypes.bool,
  hasReconsented: PropTypes.bool,
  isOptInLoading: PropTypes.bool,
  isOptOutLoading: PropTypes.bool,
  isReconsentRequired: PropTypes.bool,
  optIn: PropTypes.func,
  optOut: PropTypes.func,
  preferences: PropTypes.array,
  privacyUrlSegment: PropTypes.string,
  setUserPreferences: PropTypes.func.isRequired,
  testContent: PropTypes.shape({
    greeting: PropTypes.string,
    title: PropTypes.string,
    subtitle: PropTypes.string
  }),
  testIsLoaded: PropTypes.bool,
  termsUrlSegment: PropTypes.string
};

GDPR.defaultProps = {
  hasReconsented: null,
  preferences: [],
  testIsLoaded: false
};

export default GDPR;



// WEBPACK FOOTER //
// ./template/components/GDPR/GDPR.js